<template>
  <CommonPages id="terms" class="terms common-text" headerTheme="dark"
    titlePrefix="Terms of service">
    <div class="common-text__container">
      <div class="common-text__content pc_padding">
        <h1 class="common-text__title">Terms of Service</h1>

        <div class="common-text__section">
          <h2 class="common-text__section-title">1. Acceptance of Terms</h2>
          <p class="common-text__paragraph">
            By accessing or using {{ domainConfig?.IAmURL }} (referred to as "the Website"), you
            agree to comply with and be bound by these Terms of Service and all applicable laws and
            regulations. If you do not agree with any part of these terms, you must immediately
            discontinue using the Website.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">2. Use of the Website</h2>
          <p class="common-text__paragraph">
            The Website provides information related to automotive reviews, news, and resources. You
            may use the Website for personal, non-commercial purposes only. Any unauthorized use of
            the Website's content, including but not limited to reproduction, distribution, or
            modification, is prohibited.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">3. Content Ownership</h2>
          <p class="common-text__paragraph">
            All content on the Website, including articles, reviews, and images, are owned by
            {{ domainConfig?.IAmURL }} unless otherwise stated. You are not permitted to copy,
            republish, or distribute the content without explicit permission from the Website.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">4. User Conduct</h2>
          <p class="common-text__paragraph">
            You agree to use the Website in a manner consistent with applicable laws and
            regulations. You must not post or transmit any unlawful, harmful, or offensive content.
            Violating this provision may result in your access being restricted or terminated.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">5. Modifications to the Terms</h2>
          <p class="common-text__paragraph">
            {{ domainConfig?.IAmURL }} reserves the right to modify or update these Terms of Service
            at any time. Any changes will be posted on this page, and the updated terms will be
            effective immediately upon publication.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">6. Governing Law</h2>
          <p class="common-text__paragraph">
            These Terms of Service shall be governed by and construed in accordance with the laws of
            the jurisdiction in which the Website operates.
          </p>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import common from '@/mixin/common.js'
import reportMixin from '@/mixin/reportMixin.js'

export default {
  name: 'Terms',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'domainConfig'
    ])
  },
  mixins: [common, reportMixin]
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.common-text {
	background: #f9fbfc;
	min-height: 100vh;

	&__container {
		padding: rem(20) 0 rem(60);
	}

	&__content {
		max-width: rem(1100);
		margin: 0 auto;
		padding: rem(50);
		border-radius: rem(16);
		border: 1px solid #e9e9e9;
		background: #fff;
	}

	&__title {
		color: #050b20;

		font-size: rem(32);
		font-weight: 900;
		line-height: rem(40);
		margin-bottom: rem(24);
	}

	&__section {
		margin-bottom: rem(40);
	}

	&__section-title {
		color: #050b20;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(28);
		margin-bottom: rem(16);
	}

	&__subsection-title {
		color: #050b20;

		font-size: rem(18);
		font-weight: 600;
		line-height: rem(24);
		margin-top: rem(20);
		margin-bottom: rem(12);
	}

	&__paragraph {
		color: #4c5164;

		font-size: rem(14);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
	}

	&__link {
		color: #405ff2;
		text-decoration: underline;
		text-decoration-thickness: auto;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;

		&:hover {
			opacity: 0.8;
		}
	}

	&__list,
	&__numbered-list {
		color: #4c5164;

		font-size: rem(14);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
		padding-left: rem(20);
	}

	&__list {
		list-style-type: disc;
	}

	&__numbered-list {
		list-style-type: decimal;
	}

	&__list-item,
	&__numbered-list-item {
		margin-bottom: rem(8);

		&:last-child {
			margin-bottom: 0;
		}
	}

	&__table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: rem(20);

		font-size: rem(14);

		th,
		td {
			border: 1px solid #e9e9e9;
			padding: rem(10) rem(16);
			text-align: left;
		}

		th {
			background-color: #f5f7fa;
			color: #050b20;
			font-weight: 600;
		}

		td {
			color: #4c5164;
		}
	}

	&__blockquote {
		border-left: 4px solid #405ff2;
		padding: rem(16) rem(20);
		background-color: #f5f7fa;
		margin: rem(16) 0;
		color: #4c5164;

		font-size: rem(14);
		font-style: italic;
		line-height: rem(24);
	}

	&__code-block {
		background-color: #f5f7fa;
		border-radius: rem(8);
		padding: rem(16);
		margin: rem(16) 0;
		overflow-x: auto;

		pre {
			margin: 0;

			code {
				color: #4c5164;
				font-size: rem(14);
				line-height: 1.5;
			}
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.common-text {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);

		&__container {
			padding: rem(50) 0;
		}

		&__title {
			font-size: rem(40);
			line-height: rem(48);
		}

		&__section-title {
			font-size: rem(28);
			line-height: rem(32);
		}
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.common-text {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__content {
			padding: 0 rem(16);
		}

		&__content {
			max-width: rem(343);
			padding: rem(20);
		}

		&__title {
			font-size: rem(24);
			line-height: rem(24);
			margin-bottom: rem(20);
		}

		&__section-title {
			font-size: rem(16);
			font-style: normal;
			font-weight: 900;
			line-height: rem(24); /* 150% */
			margin-bottom: rem(8);
		}

		&__subsection-title {
			color: #050b20;

			font-size: rem(12);
			font-weight: 600;
			line-height: rem(24);
			margin-top: rem(16);
			margin-bottom: rem(8);
		}

		&__paragraph {
			color: #4c5164;

			font-size: rem(12);
			font-weight: 400;
			line-height: rem(24);
			margin-bottom: rem(8);
		}

		&__list,
		&__numbered-list {
			font-size: rem(12);
			line-height: rem(24);
			margin-bottom: rem(12);
		}

		&__list-item,
		&__numbered-list-item {
			margin-bottom: rem(6);
		}

		&__blockquote {
			font-size: rem(12);
			padding: rem(12) rem(16);
			margin: rem(12) 0;
		}

		&__table {
			font-size: rem(12);

			th,
			td {
				padding: rem(8) rem(12);
			}
		}
	}
}
</style>